import { FormikErrors } from 'formik'
import { useMemo, useState } from 'react'
import { Tone } from 'components/VoiceAndTonesSelect/Types'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import Styles from '../DesignWizardField.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'

interface Props {
  selectedTones: Tone[]
  setTone: (value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<any>>
}

export const TonesPicker = ({ selectedTones = [], setTone }: Props) => {
  const [showAllTones, setShowAllTones] = useState(false)
  const initialSelectedTones = useMemo(() => selectedTones, [showAllTones]) // eslint-disable-line react-hooks/exhaustive-deps

  const otherTones = Object.values(Tone).filter((tone) => !initialSelectedTones.includes(tone))

  return (
    <>
      {initialSelectedTones.map((tone: Tone) => (
        <Checkbox
          size="lg"
          key={tone}
          className={Styles.checkbox}
          isSelected={selectedTones.includes(tone)}
          isDisabled={!selectedTones.includes(tone) && selectedTones.length === 3}
          onChange={() => {
            const tonesSet = new Set(selectedTones)
            tonesSet.has(tone) ? tonesSet.delete(tone) : tonesSet.add(tone)
            setTone(Array.from(tonesSet).slice(0, 3))
          }}
        >
          <Text variant="smallList" color="var(--dark-80)">
            {tone}
          </Text>
        </Checkbox>
      ))}
      {otherTones.map((tone: Tone, i) => (
        <Checkbox
          size="lg"
          key={tone}
          className={cx(Styles.checkbox, {
            [Styles.hidden]: !showAllTones && i > 4 - initialSelectedTones.length,
          })}
          isSelected={selectedTones.includes(tone)}
          isDisabled={!selectedTones.includes(tone) && selectedTones.length === 3}
          onChange={() => {
            const tonesSet = new Set(selectedTones)
            tonesSet.has(tone) ? tonesSet.delete(tone) : tonesSet.add(tone)
            setTone(Array.from(tonesSet).slice(0, 3))
          }}
        >
          <Text variant="smallList" color="var(--dark-80)">
            {tone}
          </Text>
        </Checkbox>
      ))}
      {showAllTones ? (
        <div className={Styles.hideAndUnselect}>
          <div className={Styles.tag} onClick={() => setShowAllTones(false)}>
            <Text variant="label" color="var(--selected-stroke)">
              Hide
            </Text>
          </div>
          <div className={Styles.tag} onClick={() => setTone([])}>
            <Text variant="label" color="var(--selected-stroke)">
              Deselect All
            </Text>
          </div>
        </div>
      ) : (
        <div className={Styles.tag} onClick={() => setShowAllTones(true)}>
          <Text variant="label" color="var(--selected-stroke)">
            See all {Object.values(Tone).length} Tones
          </Text>
        </div>
      )}
    </>
  )
}
